<template>
  <nav class="header" >
    <div class="nav" v-if="$store.getters['user/getUser']">
      <router-link to="/dashboard">
        <img src="@/assets/img/favicon.png">{{ settings.title }} </router-link>

      <div>
        <message-circle-icon />
        <span v-if="$store.getters['rooms/getAll']"
              class="open-rooms-count">
          {{ openRoomsCount }}
        </span>

        <div class="options-menu-wrapper">
          <div v-if="$store.getters['global/isUserMenuShown'] === true"
               class="options-menu">
            <ul v-on:click="toggleOptions()">
              <li>
                <button v-if="$store.getters['user/isUserPaused']"
                        v-on:click="unbreak">
                  <sunset-icon />
                  {{ $t('header.unbreak') }}
                </button>
                <button v-else v-on:click="pause" >
                  <sunset-icon />
                  {{ $t('header.break') }}
                </button>
              </li>
              <li>
                <router-link to="/stats" v-on:click.native="toggleOptions">
                  <bar-chart-icon />{{ $t('header.stats') }}
                </router-link>
              </li>
              <li v-if="$store.getters['user/isUserSupervisor']">
                <a href="/admin">
                  <user-icon />{{ $t('header.admin') }}
                </a>
              </li>
              <li>
                <router-link to="/params" v-on:click.native="toggleOptions">
                  <settings-icon />{{ $t('header.settings') }}
                </router-link>
              </li>
              <li>
                <button v-on:click="logout()">
                  <log-out-icon />{{ $t('header.logout') }}
                </button>
              </li>
            </ul>
          </div>
          <button v-if="$store.getters['user/getUser']"
                  v-on:click="toggleOptions()">
            <p>{{ $store.getters['user/getUsername'] }}</p>
            <img :src="$store.getters['user/getAvatar']" >
            <span v-if="$store.getters['user/isUserPaused']" class="paused">
              &nbsp;
            </span>
            <span v-else class="unpaused">&nbsp;</span>
          </button>
        </div>
      </div>
    </div>
    <div class="user-stats" v-if="$store.getters['user/getHeaderStats']">
      <div>
        <h3>{{ $t('user_stats.taken_discussions') }}</h3>
        <span>{{ headerStats.running_count }}</span>
      </div>
      <div>
        <h3>{{ $t('user_stats.waiting_time') }}</h3>
        <span v-if="headerStats.average_waiting > 0">
          {{ headerStats.average_waiting | moment("utc", settings.date.longtimeFormat) }}</span>
        <span v-else>0</span>
      </div>
      <div>
        <h3>{{ $t('user_stats.conversation_time') }}</h3>
        <span v-if="headerStats.average_running > 0">
          {{ headerStats.average_running | moment("utc", settings.date.longtimeFormat)  }}
        </span>
        <span v-else>0</span>
      </div>
      <div>
        <h3>{{ $t('user_stats.customer_satisfaction') }}</h3>
        <span>{{ headerStats.average_sat }}%</span>
      </div>
    </div>
  </nav>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import VueMomentJS from 'vue-moment'
import {
  BarChartIcon, LogOutIcon, MessageCircleIcon, SettingsIcon, SunsetIcon,
  UserIcon
} from 'vue-feather-icons'

Vue.use(VueMomentJS, moment)
Vue.moment.locale(window.navigator.language)

export default {
  name: 'Header',
  components: {
    BarChartIcon,
    LogOutIcon,
    MessageCircleIcon,
    SunsetIcon,
    SettingsIcon,
    UserIcon
  },
  computed: {
    headerStats () {
      return this.$store.getters['user/getHeaderStats']
    },
    openRoomsCount () {
      if (this.$store.getters['rooms/getAll'] === null) {
        this.$socket.send({
          cmd: 'get_rooms'
        })
      }
      return this.$store.getters['rooms/getOpenRoomsCount']
    },
    settings () {
      return this.$settings
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('global/showModal', 'logout')
    },
    pause () {
      this.$store.dispatch('user/sendPause', true)
    },
    toggleOptions () {
      this.$store.commit('global/hideRoomMenu')
      this.$store.commit('global/updateUserMenuShown')
      if (this.$store.getters['global/isUserMenuShown'] === false) {
        this.$store.commit('global/hideOverlay')
      } else {
        this.$store.commit('global/showOverlay')
      }
    },
    unbreak () {
      this.$store.dispatch('user/sendPause', false)
    }
  },
  created () {
    if (this.$store.getters['user/getToken'] !== null &&
        this.$store.getters['user/getUser'] === null) {
      this.$socket.send({
        cmd: 'settings'
      })
    }
    if (this.$store.getters['user/getToken'] !== null &&
        this.$store.getters['user/getHeaderStats'] == null) {
      this.$store.dispatch('user/getHeaderStats')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/scss/global.scss';

* {
  box-sizing: border-box;
}

nav.header {
  background: #fff;
  display: flex;
  flex-direction: column;
  height: 160px;
  width: 100%;

  .nav {
    width: 100%;
    display: flex;
    height: 70px;
    justify-content: space-between;

    a {
      color: $default-color;
      font-size: 1.35rem;
      font-weight: bold;
      margin: 15px;
      text-decoration: none;

      img {
        height: 30px;
        margin: -3px 15px 0 0;
        width: 30px;
      }
    }

    div > .feather {
      display: inline-block;
      font-size: .7rem;
      position: relative;
      text-align: center;
      top: 0px;
      left: -40px;
    }

    .open-rooms-count {
      background: #23d5a9;
      border-radius: 20px;
      box-shadow: 0 0 10px #23d5a9;
      color: #fff;
      display: inline-block;
      font-size: .7rem;
      height: auto;
      min-height: 20px;
      padding: 2px 4px 2px 4px;
      position: relative;
      text-align: center;
      top: -10px;
      left: -50px;
      width: auto;
      min-width: 20px;
    }

    .options-menu-wrapper {
      position: relative;
      display: inline-block;
      right: 20px;
      z-index: 10001;

      button {
        background: none;
        border:none;
        cursor: pointer;
        outline: none;

        img {
          border-radius: 20px;
          margin: 15px 0px;
          max-height: 35px;
          max-width: 35px
        }

        p {
          display: inline-block;
          margin-right: .35rem;
        }
      }

      span {
        border-radius: 8px;
        bottom: 17px;
        height: 8px;
        position: absolute;
        right: 7px;
        width: 8px;

        &.paused {
          background: orange;
        }

        &.unpaused {
          background: #23d5a9;

        }
      }

      .options-menu {
        right: 10px;
        top: 60px;
        min-width: 200px;

        a, button {
          font-weight: normal;
          margin: 0;
        }
      }
    }
  }

  .user-stats {
    align-items: center;
    background: #0e1c3d;
    color: #fff;
    display: flex;
    flex-direction: row;
    height: 90px;
    justify-content: space-between;
    width: 100%;

    > div {
      margin: 0 1rem;
      width: 25%;
    }

    h3 {
      font-size: 1em;
      line-height: 1em;
      margin: 0;
      opacity: 0.6;
      padding: 5px;
      text-align: center;
    }

    span {
      display: block;
      text-align: center;
    }
  }
}

</style>
